export enum SortOrder {
	ASC = 'asc',
	DESC = 'desc',
}

export type ObjectID = string;

// biome-ignore lint/suspicious/noExplicitAny: Init Biome
export type LabelValue<T = any> = {
	label: string;
	value: T;
	selected?: boolean;
};

export type Timestamp = number;
export type DataSet<T> = { [key: string]: T };

export interface DB {
	id: ObjectID;
	createdAt?: number;
	updatedAt?: number;
}

export type Geolocation = number[];

export interface Pagination<T, S = null> {
	page: number;
	limit: number;
	total: number;
	totalPages: number;
	items: T[];
	stats?: S;
}
